import { translate } from "../translate/translate";

export const formatMoney = (
    value: string | number | null | undefined,
    currency?: string | null,
    fractionDigits = 2,
): string => {
    if (value === null || value === undefined || value === "") return "-";

    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return "-";

    const locale = translate.language === "en" ? "en-US" : "pt-BR";
    const normalizedCurrency = currency?.toUpperCase();
    const formattedValue = new Intl.NumberFormat(locale, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(numberValue);

    if (normalizedCurrency === "BRL") {
        return `R$ ${formattedValue}`;
    }

    if (normalizedCurrency === "USD") {
        return `$ ${formattedValue}`;
    }

    return normalizedCurrency ? `${normalizedCurrency} ${formattedValue}` : formattedValue;
};

export const parseLocaleNumber = (value: number | undefined | null, cropZeros = true): string => {
    // Verificar se o valor é válido
    if (value === undefined || value === null || isNaN(value)) {
        return "0";
    }

    const language = translate.language;

    const formattedValue = cropZeros || Number.isInteger(value)
        ? value.toFixed(0)
        : value.toFixed(3);

    return new Intl.NumberFormat(
        language === "en" ? "en-US" : "pt-BR",
        {
            minimumFractionDigits: 0,
            maximumFractionDigits: 3,
        }
    ).format(Number(formattedValue));
};

/**
 * Formats a number in compact notation (e.g. 1.234.567 -> "1,2 mi" / "1.2M"),
 * useful for axis labels where space is limited. Falls back to "0" for
 * invalid input, matching parseLocaleNumber's behavior.
 */
export const formatCompactNumber = (value: number | undefined | null): string => {
    if (value === undefined || value === null || isNaN(value)) {
        return "0";
    }

    const language = translate.language;

    return new Intl.NumberFormat(
        language === "en" ? "en-US" : "pt-BR",
        {
            notation: "compact",
            compactDisplay: "short",
            maximumFractionDigits: 1,
        }
    ).format(Number(value));
};
